/* eslint-disable no-script-url */
import clsx from 'clsx'
import {_} from 'i18n'
import React from 'react'
import {Dropdown} from 'react-bootstrap'
import {OverlayTrigger, Tooltip} from 'react-bootstrap'
import {useTranslation} from 'react-i18next'

import {toAbsoluteUrl} from '../../../../_helpers'
import {DropdownTopbarItemToggler} from '../../../../_partials/dropdowns'

const languages = [
  {
    lang: 'pt-BR',
    name: _`Português`,
    flag: toAbsoluteUrl('/media/svg/flags/011-brazil.svg'),
  },
  {
    lang: 'en',
    name: _`English`,
    flag: toAbsoluteUrl('/media/svg/flags/226-united-states.svg'),
  },
  {
    lang: 'es',
    name: _`Español`,
    flag: toAbsoluteUrl('/media/svg/flags/128-spain.svg'),
  },
]

export function LanguageSelectorDropdown() {
  const {i18n} = useTranslation()
  const currentLanguage = languages.find((x) => x.lang === i18n.language) || languages[0]

  const handleChangeLanguage = (lang) => {
    i18n.changeLanguage(lang)
  }

  return (
    <Dropdown drop="down" alignRight>
      <Dropdown.Toggle as={DropdownTopbarItemToggler} id="dropdown-toggle-my-cart">
        <OverlayTrigger
          placement="bottom"
          overlay={<Tooltip id="language-panel-tooltip">{_`Selecione o idioma`}</Tooltip>}>
          <div className="btn btn-icon btn-hover-transparent-white btn-dropdown btn-lg mr-1">
            <img className="h-20px w-20px rounded-sm" src={currentLanguage.flag} alt={currentLanguage.name} />
          </div>
        </OverlayTrigger>
      </Dropdown.Toggle>
      <Dropdown.Menu className="dropdown-menu p-0 m-0 dropdown-menu-anim-up dropdown-menu-sm dropdown-menu-right">
        <ul className="navi navi-hover py-4">
          {languages.map((language) => (
            <li
              key={language.lang}
              className={clsx('navi-item', {
                active: language.lang === currentLanguage.lang,
              })}>
              <a href="#" onClick={() => handleChangeLanguage(language.lang)} className="navi-link">
                <span className="symbol symbol-20 mr-3">
                  <img src={language.flag} alt={language.name} />
                </span>
                <span className="navi-text">{language.name}</span>
              </a>
            </li>
          ))}
        </ul>
      </Dropdown.Menu>
    </Dropdown>
  )
}
